import { render, staticRenderFns } from "./TicketsSubmit.vue?vue&type=template&id=0e53541f&scoped=true&"
import script from "./TicketsSubmit.vue?vue&type=script&lang=js&"
export * from "./TicketsSubmit.vue?vue&type=script&lang=js&"
import style0 from "./TicketsSubmit.vue?vue&type=style&index=0&id=0e53541f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53541f",
  null
  
)

export default component.exports